var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('section',{staticClass:"main-section"},[_c('MainPage')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }